import { CLIP_CUSTOMIZER_WARNING, CLIP_CUSTOMIZER_WARNING_TYPE } from '../../ClipCustomizer/useClipCustomizerWarnings';
import IconButton from '@/components/atoms/Button/IconButton';
import TooltipV2 from '@/components/TooltipV2';
import Icon from '@/components/atoms/Icon';

export default function MatchSpeakersCTA({
  onClick,
  warnings
}: {
  onClick: () => void;
  warnings: CLIP_CUSTOMIZER_WARNING['warnings'];
}) {
  return (
    <div className="mt-4 flex items-center justify-between rounded-md">
      <div className="flex items-center gap-1 text-xs text-slate-700">
        Speakers not correctly identified?
        {warnings[CLIP_CUSTOMIZER_WARNING_TYPE.SPEAKER_FACE_MAPS_INCOMPLETE] && (
          <TooltipV2
            place="left"
            tooltipId="speaker-face-maps-incomplete-tooltip"
            tooltipContent={CLIP_CUSTOMIZER_WARNING_TYPE.SPEAKER_FACE_MAPS_INCOMPLETE}
            size="xsmall"
            tooltipElement={
              <Icon name="IconAlertTriangle" className="size-3 cursor-pointer text-theme-input-warning" />
            }
            colorTheme="light"
          />
        )}
      </div>
      <IconButton
        icon="IconUserEdit"
        content="Identify Speakers"
        onClick={onClick}
        size="small"
        trackingId="match-speakers-button"
      />
    </div>
  );
}
